import {
	fetchFicheProduit,
	fetchFicheProduitUri,
	fetchFirstProducts,
} from "app/pages/Listing/productActionCreators";
import {
	fetchMerchandisingLight,
	fetchMerchandisings,
} from "app/pages/Merchandising/merchandisingActionCreators";
import { getContextualizedSignupPagesPagesAuth } from "app/pages/SignupPage/Auth/SignupAuthActionCreators";
import { fetchSDPAccommodationDescription } from "app/pages/SmartDP/smartDPActionCreators";
import { fetchLandingPage } from "app/pages/LandingPage/landingPageActionCreators";
import { fetchPaymentMethods } from "app/pages/Booking/Payment/paymentActionCreators";
import { fetchHotelOnlyAccommodationDescription } from "app/pages/HotelOnly/Booking/pages/Quote/BookingQuoteActionCreator";
import { getHotelAccommodationDescriptionQuery } from "app/features/hotel/hotelDescription/hooks/useHotelAccommodationDescription";
import { parseTunnelParam } from "app/types/tunnel";

export const getRoutes = shop => [
	{
		path: `/${shop}/home`,
	},
	{
		path: `/${shop}/home/login`,
	},
	{
		path: `/${shop}/home/signup`,
	},
	{
		path: `/${shop}/auth`,
	},
	{
		path: `/${shop}/giveaway`,
	},
	{
		path: `/${shop}/unsubscribe`,
	},
	{
		path: `/${shop}/account`,
	},
	{
		path: `/${shop}/account/profile`,
	},
	{
		path: `/${shop}/account/customer-request/:request`,
	},
	{
		path: `/${shop}/account/mybookings/:bookingReference`,
	},
	{
		path: `/${shop}/account/mybookings`,
	},
	{
		path: `/${shop}/account/security`,
	},
	{
		path: `/${shop}/account/subscriptions`,
	},
	{
		path: `/${shop}/account/sponsorship`,
	},
	{
		path: `/${shop}/account/mycredits`,
	},
	{
		path: `/${shop}/account/myrefunds`,
	},
	{
		path: `/${shop}/account/faq-contact`,
	},
	{
		path: `/${shop}/account/faq-chatbot`,
	},
	{
		path: `/${shop}/sign-up/:operationCode/*`,
		ssrActionCreators: [getContextualizedSignupPagesPagesAuth],
	},
	{
		path: `/${shop}/landing-pages/:landingPageCode`,
		ssrActionCreators: [fetchLandingPage],
	},
	{
		path: `/${shop}/schizophrene`,
	},
	{
		path: `/${shop}/priceMatchGuarantee`,
	},
	{
		path: `/${shop}/booking`,
	},
	{
		path: `/${shop}/external-redirect`,
	},
	{
		path: `/${shop}/confirmation`,
	},
	{
		path: `/${shop}/not-found`,
	},
	{
		path: `/${shop}/technical-error`,
	},
	{
		path: `/${shop}/technical-error/registration-confirmation-expired`,
	},
	{
		path: `/${shop}/technical-error/confirm-registration-failed`,
	},
	{
		path: `/${shop}/technical-error/sso`,
	},
	{
		path: `/${shop}/technical-error/duplicate-booking`,
	},
	{
		path: `/${shop}/mybookings`,
	},
	{
		path: `/${shop}/magazine`,
	},
	{
		path: `/${shop}/listing`,
		ssrActionCreators: [fetchFirstProducts, fetchMerchandisings, fetchPaymentMethods],
	},
	{
		path: `/${shop}/merch`,
		ssrActionCreators: [fetchMerchandisingLight, fetchPaymentMethods],
	},
	{
		path: `/${shop}/stopover/search`,
	},
	{
		path: `/${shop}/stopover/listing`,
	},
	{
		path: `/${shop}/stopover/booking/quote`,
	},
	{
		path: `/${shop}/stopover/booking/payment`,
	},
	{
		path: `/${shop}/stopover/booking/confirmation`,
	},
	{
		path: `/${shop}/stopover/hotelDescription/:accommodationId/:code`,
		ssrActionCreators: [fetchSDPAccommodationDescription],
	},
	{
		path: `/${shop}/sdp/search`,
	},
	{
		path: `/${shop}/sdp/listing`,
	},
	{
		path: `/${shop}/sdp/listing/map`,
	},
	{
		path: `/${shop}/sdp/booking/quote`,
	},
	{
		path: `/${shop}/sdp/booking/payment`,
	},
	{
		path: `/${shop}/sdp/booking/confirmation`,
	},
	{
		path: `/${shop}/sdp/hotelDescription/:accommodationId/:code`,
		ssrActionCreators: [fetchSDPAccommodationDescription],
	},
	{
		path: `/${shop}/hotel/:tunnel/:country/:resort/:propertyType/:accommodationId/:hotelName`,
		ssrQueries: [
			({ tunnel, accommodationId, partnerCode }) =>
				getHotelAccommodationDescriptionQuery(
					accommodationId,
					parseTunnelParam(tunnel),
					partnerCode
				),
		],
	},
	{
		path: `/${shop}/hotelonly/hotelDescription/:accommodationId/:code`,
		ssrActionCreators: [fetchHotelOnlyAccommodationDescription],
	},
	{
		path: `/${shop}/product/id/:productId`,
		ssrActionCreators: [fetchFicheProduitUri],
	},
	{
		path: `/${shop}/booking/quote`,
	},
	{
		path: `/${shop}/booking/payment`,
	},
	{
		path: `/${shop}/booking/confirmation`,
	},
	{
		path: `/${shop}/booking-auth`,
	},
	{
		path: `/${shop}/booking-search`,
	},
	{
		path: `/${shop}/ourcommitments`,
	},
	{
		path: `/${shop}/faq`,
	},
	{
		path: `/${shop}/faq/category/:categoryId`,
	},
	{
		path: `/${shop}/faq/category/:categoryId/subcategory/:subCategoryId`,
	},
	{
		path: `/${shop}/faq/category/:categoryId/subcategory/:subCategoryId/article/:articleId`,
	},
	{
		path: `/${shop}/page/:slug`,
	},
	{
		path: `/${shop}/cookie-policy`,
	},
	{
		path: `/${shop}/:productUri`, // have to be the last route ou that array
		ssrActionCreators: [fetchFicheProduit, fetchPaymentMethods],
	},
	{
		path: `/${shop}`,
		ssrActionCreators: [fetchFirstProducts, fetchMerchandisings, fetchPaymentMethods],
	},
];
